import { Injectable } from '@angular/core';

import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { QueryService } from '../../shared/query.service';
import { Size } from '../../_models/size';
import { Update } from '../../_models/update';
import { Product } from '../../_models/product';
import { Template } from '../../_models/template';
import { OverviewService } from '../overview/overview.service';


@Injectable()
export class CardService {
  public loadingCards = true;
  public product: Product;
  public sizes: Size[] = [];
  public similarProducts: Product[] = [];
  public showCardSize: Boolean[] = [];
  public uploading: Boolean = false;
  public newImage: string = null;

  constructor(private queryService: QueryService, private overviewService: OverviewService) {}

  setProduct(product_id: any): Observable<any> {
    return this.getProduct(product_id).map(data => {
      this.product = data;
      const status = this.product.status;
        this.overviewService.getSimilarProducts(data, status).subscribe(data => {
          this.similarProducts = data;
        });
      this.setSizes(this.product.id);
    });
  }

  getProduct(product_id: any): Observable<any> {
    const url = '/products/' + product_id + '/';
    return this.queryService.getQuery(url).map(result => {
        return result;
      }
    );
  }

  setSizes(product_id:any):void {
    this.getSizes(product_id).subscribe(data => {
      this.sizes = data;
      // Reset our old showCardSize array
      this.showCardSize = [];
      // By default, only show the first two card sizes
      this.showCardSize[this.sizes[0].id] = true;
      this.showCardSize[this.sizes[1].id] = true;
    });
  }

  getSizes(product_id:any):Observable<any> {
    this.loadingCards = true;
    let url = '/cards/cards/detail/?product_id=' + product_id;
    return this.queryService.getQuery(url).map(result => {
      this.loadingCards = false;
      return result;
    });
  }

  uploadImage(new_image:File) {
    this.uploading = true;
    let url = '/products/photo/';
    let newImagePayload = new FormData();

    newImagePayload.append('product_id', this.product.id);
    newImagePayload.append('photo', new_image, new_image.name);

    return this.queryService.postQueryFormData(url, newImagePayload).map(result => {
      this.uploading = false;
      let output = result['photo'];
      return output;
    });
  }

  closeUploading() {
    this.uploading = false;
    this.newImage = null;
  }

  checkIfSelected(template: Template): boolean {
    if (template.selected) {
      return true;
    } else {
      return false;
    }
  }

  toggleTemplate(template: Template) {
    if (template.selected) {
      template.selected = false;
    } else {
      template.selected = true;
    }
  }

  toggleSize(cardSizeID: number) {
    this.showCardSize[cardSizeID] = !this.showCardSize[cardSizeID];
  }

  getNumberOfSelectedTemplates(): number {
    let output = 0;
    for (let size of this.sizes) {
      for (let template_id of size.cards) {
        if (this.checkIfSelected(template_id)) {
          output = output + 1;
        }
      }
    }
    return output;
  }

  getCardsToUpdate(): Update[] {
    let cards: Update[] = [];
    for (let size of this.sizes) {
      for (let template of size.cards) {
        let newCard = new Update(template);
        cards.push(newCard);
      }
    }
    return cards;
  }

  submitProducts(productIDsThatShouldBeUpdated:string[] = []):Observable<any> {
    // Extract all templates for the current card we are working on
    let templates: Update[] = this.getCardsToUpdate();
    let queriesToBeExecuted:Observable<any>[] = [];
    for (let id of productIDsThatShouldBeUpdated) {
      queriesToBeExecuted.push(this.createUpdateProductTemplateObservable(id, templates));
    }
    // Forkjoin creates a single observable from an array of observables. If all observables return their output,
    // the forkJoin observable returns a list with all results
    return Observable.forkJoin(queriesToBeExecuted);
  }

  createUpdateProductTemplateObservable(product_id:string, templates:Update[]):Observable<any> {
    let url = '/cards/process/' + product_id + '/';
    let payload = JSON.stringify({cards: templates});
    return this.queryService.postQuery(url, payload).map(result => {
      return result;
    });
  }

  updateValueIfItExistsInTemplate(name:string, container:any, value:string):void {
    let element = container.querySelector(name);
    if (element) {
      element.innerHTML = value;
    }
  }

  updateTemplate(template:Template, update:Update):void {
    let container = document.createElement('div');
    container.innerHTML = template.svg;

    if (update.brand) {
      this.updateValueIfItExistsInTemplate('.brand', container, update.brand);
    }
    if (update.type) {
      this.updateValueIfItExistsInTemplate('.type', container, update.type);
    }
    if (update.usps) {
      for (let entry in update.usps) {
        let my_entry = update.usps[entry];
        this.updateValueIfItExistsInTemplate('.' + my_entry.id, container, my_entry.value);
      }
    }

    // If our update contains a new photo
    if (update.photo) {
      let picture = container.querySelector('.photo');
      // If our template has a photo div
      if (picture) {
        picture.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', update.photo);
      }
    }
    if (template.allow_second_product && update.second_product_id) {
      template.second_product_id = update.second_product_id;
      this.updateValueIfItExistsInTemplate('.v1_price_text', container, update.v1_price_text);
      this.updateValueIfItExistsInTemplate('.v2_price_text', container, update.v2_price_text);
    }
    template.svg = container.innerHTML;
  }

  createNewTemplate(size: Size, template: Template) {
    let sizes = size.cards.push(template);
  }

  copyUpdateToSize(update_to_copy:Update, size_name:string): void {
    for (let size of this.sizes) {
      if (size.name === size_name) {
        for (let t of size.cards) {
          this.updateTemplate(t, update_to_copy);
        }
      }
    }
  }

  copyUpdateToTemplate(update_to_copy:Update, size_name:string, template_name:string): void {
    for (let size of this.sizes) {
      if (size.name === size_name) {
        for (let t of size.cards) {
          if (t.name === template_name) {
            this.updateTemplate(t, update_to_copy);
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/card.service.ts